import React from 'react'
// @ts-ignore
import { ReactComponent as ResourcesNull } from './resources-null.svg'
import { color, Text } from '@trivie/ui-mobile'

export const LibraryResourcesNull = (props: any) => {
  const { style } = props
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 104,
        ...style,
      }}
    >
      <ResourcesNull />
      <Text
        variant="body1Medium"
        tx="Resources.nullResources"
        style={{ textAlign: 'center', color: color.shade50, marginTop: 26, width: 250 }}
      />
    </div>
  )
}
